import React, {FC} from 'react';
import {NavLink} from 'react-router-dom';

const style = {
	// Same as GoogleSigninButton
	navLink: `flex justify-center items-center   transition ease-in-out delay-75 duration-150 hover:delay-0 hover:duration-0   w-full h-10   font-whirlwindSecondary text-2xl text-center text-whirlwindLightest hover:text-whirlwindLight   bg-whirlwindPrimary hover:bg-whirlwindPrimaryDark   border-whirlwindPrimaryDarkest`,
	navLinkActive: `flex justify-center items-center   transition ease-in-out delay-75 duration-150 translate-y-2   w-full h-10   font-whirlwindSecondary text-2xl text-center text-whirlwindPrimaryLight   bg-whirlwindDark   border-whirlwindPrimaryDarkest`,
};

type NavbarButtonProps = {
	extendcss?: string;
	id: string;
	route: string;
	textContent: string;
};

export const NavbarButton: FC<NavbarButtonProps> = ({
	extendcss,
	id,
	route,
	textContent,
}) => {
	return (
		<NavLink
			className={({isActive}) =>
				isActive
					? `${style.navLinkActive} ${extendcss}`
					: `${style.navLink} ${extendcss}`
			}
			data-test-id={`${id}_TEST`}
			id={id}
			to={route}>
			<div>{textContent}</div>
		</NavLink>
	);
};
